export const firstLevel = 10;
export const secondLevel = 100;
export const thirdLevel = 1000;
export const fourthLevel = 10000;
export const fifthLevel = 100000;